import { getTutorLessonDurationCancle, getRemainingCancelCountOfThisWeek } from '@/api/classtable'
import { isToday } from 'date-fns'

const classtable = {
  namespaced: true,

  state: {
    viewRange: {
      start: new Date(),
      end: new Date()
    },
    events: [],
    currentView: 0, // [day, week]
    currentDate: new Date(),
    loading: false,
    hadInited: false,
    canGoNext: true,
    canGoLast: false,
    canSubmit: false,
    selectData: [],
    nextNumber: 0,
    nextNumbers: 0
  },
  mutations: {
    SET_VIEW_RANGE: (state, viewRange) => {
      state.viewRange = viewRange
    },
    SET_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_CANGONEXT: (state, canGoNext) => {
      state.canGoNext = canGoNext
    },
    SET_CANGOLAST: (state, canGoLast) => {
      state.canGoLast = canGoLast
    },
    SET_CURRENT_VIEW: (state, view) => {
      state.currentView = view
    },
    SET_CURRENT_DATE: (state, date) => {
      state.currentDate = date
    },
    SET_EVENTS: (state, events) => {
      state.events = events
    },
    SET_HAD_INITED: (state, value) => {
      state.hadInited = value
    },

    PUSH_DATA: (state, value) => {
      state.canSubmit = true
      state.selectData.push(value)
      // let a = state.nextNumbers
      // state.nextNumber = a - state.selectData.length
      if(!value.isNextClass) state.nextNumber--
      
    },
    DELETE_DATA: (state, value) => {
      state.selectData = state.selectData.filter(e => e.id != value.id)
      // let a = state.nextNumbers
      // state.nextNumber = a - state.selectData.length
      if(!value.isNextClass) state.nextNumber++
      if (state.selectData.length === 0 || state.nextNumber === 0) { state.canSubmit = false }
      
    },
    SET_NEXT_NUMBER: (state, data) => {
      state.nextNumber = data
      state.nextNumbers = data
    }
  },
  actions: {
    updateData ({ commit }, value) {
      
      if (value.cancle) { 
        commit('PUSH_DATA', value) 
      } else { 
        commit('DELETE_DATA', value) 
      }
    },
    setCurrentDate ({ commit }, date) {
      commit('SET_CURRENT_DATE', date)
    },
    // 这个action在每次切换日期的时候都会被调用, 判断缓存的数据范围是否改变并更新数据
    setViewRange ({ commit, dispatch, state }, { start, end }) {
      // var startDay=start.getDate()
      // var currDay=new Date().getDate()
      // if(startDay<currDay){
      //   start.setDate(currDay)
      //   end.setDate(currDay+7)
      // }

      // 第一次设置事件范围的时候,标记已初始化
      if (state.hadInited === false) {
        commit('SET_HAD_INITED', true)
      }
      if (
        state.viewRange.start.getTime() === start.getTime() &&
        state.viewRange.end.getTime() === end.getTime()
      ) {
        return
      }
      commit('SET_VIEW_RANGE', { start, end })
      dispatch('fetchData')
    },
    async fetchData ({ commit, state }) {
      commit('SET_LOADING', true)
      getTutorLessonDurationCancle(state.viewRange.start, state.viewRange.end)
        .then(res => {
          commit('SET_EVENTS', res)
        })
        .finally(() => {
          commit('SET_LOADING', false)
        })
    },
    prev ({ commit, state, dispatch }) {
      const prev = new Date(state.currentDate.getTime())
      prev.setDate(prev.getDate() - 7)
      commit('SET_CURRENT_DATE', prev)

      commit('SET_CANGOLAST', state.currentDate > new Date())
      commit('SET_CANGONEXT', true)
      commit('SET_NEXT_NUMBER', state.nextNumbers)
      state.selectData = [] //清空已选数据

    },
    next ({ commit, state, dispatch }) {
      const next = new Date(state.currentDate.getTime())
      next.setDate(next.getDate() + 7)
      commit('SET_CURRENT_DATE', next)
      commit('SET_CANGOLAST', true)

      var end = state.viewRange.end
      var curr = new Date().setDate(new Date().getDate() + 14)
      var max = end.setDate(end.getDate() + 7)

      commit('SET_CANGONEXT', max < curr)
      commit('SET_NEXT_NUMBER', state.nextNumbers)
      state.selectData = []
      
    },
    getThisWeekCount({ commit, state }) { //获取本周的剩余取消计数
      getRemainingCancelCountOfThisWeek()
        .then(res => {
          commit('SET_NEXT_NUMBER', res)
        })
    },

  },
  getters: {
    events: state => state.events,
    currentDate: state => state.currentDate,
    loading: state => state.loading,
    hadInited: state => state.hadInited,
    canSubmit: state => state.canSubmit,
    selectData: state => state.selectData,
    viewRange: state => state.viewRange,
    canGoNext: state => state.canGoNext,
    canGoLast: state => state.canGoLast,
    nextNumber: state => state.nextNumber
  }
}
export default classtable
